// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XfjC_","clinicsSelect":"styles_clinicsSelect__2aoqA"};